import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import './assets/css/tailwind.css'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// plugin for country flags
import FlagIcon from 'vue-flag-icon'
Vue.use(FlagIcon)

import { IconService } from './services/icon.service'
Vue.prototype.$icons = IconService

import router from './router'

import i18n from './services/language.service'

import ApiService from './services/api.service'
// inits the api service and adds it to the vue instance
ApiService.init('/')
Vue.prototype.$http = ApiService

let hostname = 'https://api.cybo.de'
if (process.env.NODE_ENV === 'development') {
    hostname = 'http://localhost:8080'
}

Vue.prototype.$payload = {
    HOSTNAME: hostname
}

new Vue({
    router,
    i18n,
    render: (h) => h(App)
}).$mount('#app')
